const button_data = [
  {
    name: "All Activity",
    value: "All Activity",
  },
  {
    name: "Video Edits",
    value: "Video Edits",
  },
  {
    name: "Video Shared",
    value: "Video Shared",
  },
  {
    name: "Members Added",
    value: "Members Added",
  },
  {
    name: "Season Added",
    value: "Season Added",
  },
  {
    name: "Schedule Added",
    value: "Schedule Added",
  },
];

const button_data2 = [
  {
    name: "All Activity",
    value: "All Activity",
  },
  {
    name: "Videos",
    value: "Videos",
  },
  {
    name: "Offensive Play Of The Week",
    value: "Offensive Play Of The Week",
  },
  {
    name: "Defensive Play Of The Week",
    value: "Defensive Play Of The Week",
  },
];

export { button_data };
export { button_data2 };
